<mb-base-modal>
  <div class="content" dialog-content>
    @if (isLoading | async) {
      <div class="buffering-container">
        <mb-buffering class="dark"></mb-buffering>
        <h4>{{ 'EMBARGO_CONFIRM_PROCESSING' | translate }}</h4>
      </div>
    }
    @if ((isLoading | async) === false) {
      <div class="pre-media-confirmation copy-m">
        <div class="pre-media-confirmation-content">
          <div class="headline-container">
            <span class="modal-headline h3" translate="EMBARGO_CONFIRM_HEADLINE"></span>
          </div>
          <div class="subline-container">
            <span class="modal-subline" translate="EMBARGO_CONFIRM_SUBLINE"></span>
          </div>
          <div class="date-list-container">
            @for (embargoDate of formattedDatetimes; track embargoDate) {
              <p class="date-list-container-item">
                {{ embargoDate }}
              </p>
            }
          </div>
          <mb-checkbox [checked]="confirmed" (checkChange)="confirmed = $event">
            <span>{{ 'EMBARGO_CONFIRM_CHECK_LABEL' | translate }}</span>
          </mb-checkbox>
        </div>
        <div class="actions">
          <button class="btn btn-primary" [disabled]="!confirmed" (click)="confirm.emit()" translate="CONFIRM"></button>
          <button class="btn btn-tertiary" (click)="requestCancel.emit()" translate="CANCEL"></button>
        </div>
      </div>
    }
  </div>
</mb-base-modal>
